module.exports = __webpack_public_path__ + "static/media/garden trail.45dbd18b.jpg";